export const APPLICATION_ID = 'cdf-ui-data-exploration';
